import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputContext } from './Input.context';
import { Icon } from './components';
import { useClassName } from '../../hooks';
import './Input.scss';
/**
 * Text input used to capture user input.
 */
export const Input = ({ endIcon, onEndIconClick, testId, ...props }) => {
    const containerClassName = useClassName({ name: 'input-container', prefixed: true });
    const inputClassName = useClassName({ name: 'input', prefixed: true });
    return (_jsx(InputContext.Provider, { value: { endIcon, onEndIconClick }, children: _jsxs("div", { className: containerClassName, children: [_jsx("input", { "data-testid": testId, className: inputClassName, ...props }), _jsx(Icon, {})] }) }));
};
